import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function StatementIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66669 12.4305V5.36943C2.66669 3.46675 2.66669 2.51542 3.25247 1.92434C3.83826 1.33325 4.78107 1.33325 6.66669 1.33325H9.33335C11.219 1.33325 12.1618 1.33325 12.7476 1.92434C13.3334 2.51542 13.3334 3.46675 13.3334 5.36943V12.4305C13.3334 13.4383 13.3334 13.9421 13.0254 14.1405C12.5221 14.4647 11.7441 13.7849 11.3528 13.5381C11.0294 13.3342 10.8678 13.2323 10.6884 13.2264C10.4945 13.22 10.33 13.3178 9.98062 13.5381L8.70669 14.3415C8.36302 14.5582 8.19122 14.6666 8.00002 14.6666C7.80882 14.6666 7.63702 14.5582 7.29335 14.3415L6.01944 13.5381C5.69612 13.3342 5.53446 13.2323 5.35504 13.2264C5.16117 13.22 4.99664 13.3178 4.64727 13.5381C4.25599 13.7849 3.47793 14.4647 2.97465 14.1405C2.66669 13.9421 2.66669 13.4383 2.66669 12.4305Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6666 4H5.33331"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66665 6.66675H5.33331"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66669 6.58333C9.11442 6.58333 8.66669 6.97507 8.66669 7.45833C8.66669 7.9416 9.11442 8.33333 9.66669 8.33333C10.219 8.33333 10.6667 8.72507 10.6667 9.20833C10.6667 9.6916 10.219 10.0833 9.66669 10.0833M9.66669 6.58333C10.1021 6.58333 10.4725 6.8268 10.6098 7.16667M9.66669 6.58333V6M9.66669 10.0833C9.23129 10.0833 8.86089 9.83987 8.72362 9.5M9.66669 10.0833V10.6667"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
